const getChartColumnHeight = (yValue: number, upperYValue: number) => {
  const percent = Math.round((yValue / upperYValue) * 100);
  return `${percent}%`;
};

export { getChartColumnHeight };
